import React, {useState} from "react";
import {Platform} from "react-native";
import {usePatronTheme, Box, Button, FormGroup, TextInput} from "@unibuddy/patron";
import {IconEye, IconEyeSlash} from "@unibuddy/icons";

type PasswordInputProps = {
    name: string;
    required?: boolean;
    helpBottom?: React.ReactNode;
    [key: string]: any;
};

export const PasswordInput = ({
    name,
    required = false,
    helpBottom,
    ...props
}: PasswordInputProps) => {
    const theme = usePatronTheme();
    const [showPassword, setShowPassword] = useState(false);
    const isAndroid = Platform.OS === "android";
    return (
        <Box position="relative">
            <FormGroup label="Password" helpBottom={isAndroid ? null : helpBottom}>
                <TextInput
                    name={name}
                    secureTextEntry={!showPassword}
                    required={required}
                    style={{paddingRight: 60}}
                    {...Platform.select({
                        web: {
                            type: showPassword ? "text" : "password",
                        },
                        native: {
                            autoCompleteType: "password",
                            importantForAutofill: "yes",
                        },
                    })}
                    {...props}
                />
            </FormGroup>

            <Box position="absolute" right={4} top={24} zIndex={1}>
                <Button
                    clear
                    type="button"
                    iconOnly
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    role="switch"
                    aria-checked={showPassword}
                    accessibilityRole="switch"
                    accessibilityLabel={showPassword ? "Hide password" : "Show password"}
                >
                    {showPassword ? (
                        <IconEyeSlash color={theme?.colors?.textColor} />
                    ) : (
                        <IconEye color={theme?.colors?.textColor} />
                    )}
                </Button>
            </Box>
        </Box>
    );
};
